// Lead-conversion pixel firing for TikTok, Meta (Facebook/Instagram), and Google Ads.
// Each pixel is OPTIONAL: if its env var is empty, that pixel is silently skipped.
// Env vars (set in /app/frontend/.env):
//   REACT_APP_TIKTOK_PIXEL_ID
//   REACT_APP_META_PIXEL_ID
//   REACT_APP_GOOGLE_ADS_ID             e.g. "AW-1234567890"
//   REACT_APP_GOOGLE_CONVERSION_LABEL   e.g. "abcDEF123"

const TIKTOK_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || "";
const META_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const GOOGLE_CONVERSION_LABEL = process.env.REACT_APP_GOOGLE_CONVERSION_LABEL || "";

let initialized = false;

function injectScript(src, async = true) {
    const s = document.createElement("script");
    s.src = src;
    s.async = async;
    document.head.appendChild(s);
    return s;
}

function initTikTok() {
    if (!TIKTOK_ID || window.ttq) return;
    /* eslint-disable */
    (function (w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = (w[t] = w[t] || []);
        ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
        ttq.setAndDefer = function (t, e) {
            t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
        };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
        ttq.instance = function (t) {
            var e = ttq._i[t] || [];
            for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
            return e;
        };
        ttq.load = function (e, n) {
            var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
            ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i;
            ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = n || {};
            var o = document.createElement("script"); o.type = "text/javascript"; o.async = !0;
            o.src = i + "?sdkid=" + e + "&lib=" + t;
            var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a);
        };
        ttq.load(TIKTOK_ID); ttq.page();
    })(window, document, "ttq");
    /* eslint-enable */
}

function initMeta() {
    if (!META_ID || window.fbq) return;
    /* eslint-disable */
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
        t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", META_ID);
    window.fbq("track", "PageView");
    /* eslint-enable */
}

function initGoogleAds() {
    if (!GOOGLE_ADS_ID || window.gtag) return;
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GOOGLE_ADS_ID);
}

export function initPixels() {
    if (initialized || typeof window === "undefined") return;
    initialized = true;
    try { initTikTok(); } catch (e) { /* ignore */ }
    try { initMeta(); } catch (e) { /* ignore */ }
    try { initGoogleAds(); } catch (e) { /* ignore */ }
}

export function trackLead({ id, service = "Electricity", channel } = {}) {
    if (typeof window === "undefined") return;
    try {
        if (window.ttq) window.ttq.track("SubmitForm", { content_id: id, content_name: service, channel });
    } catch (_) {}
    try {
        if (window.fbq) window.fbq("track", "Lead", { content_name: service, content_category: channel || "web" });
    } catch (_) {}
    try {
        if (window.gtag && GOOGLE_ADS_ID && GOOGLE_CONVERSION_LABEL) {
            window.gtag("event", "conversion", {
                send_to: `${GOOGLE_ADS_ID}/${GOOGLE_CONVERSION_LABEL}`,
                transaction_id: id || "",
            });
        }
    } catch (_) {}
}
